import { HttpResponse, delay, http } from 'msw'
import { setupWorker } from 'msw/browser'

import apiKeyResponse from './mocks/apikey'

export const worker = setupWorker(
  http.get('/api/apikey/:email', async (info) => {
    await delay(1500)
    return HttpResponse.json(apiKeyResponse, { status: 202, statusText: 'Mocked status' })
  })
)
